import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import { mapState } from 'vuex';
import ToHelper from '@ps/views/workbench/board/bottom-bar/to-helper';
import ResizeObserver from 'resize-observer-polyfill';
import AccountFeedback from '@pt/components/account-feedback';
import { ptEventter } from '../utils/event-bus';
import { t } from '@/lang';

export default {
  data: function data() {
    return {
      winWidth: 0,
      winHeight: 0,
      robserver: null,
      messageIconColor: '#999',
      guideIconColor: '#999',
      assistantIconColor: '#999',
      messageDialog: false,
      guideText: t('playTurbo.guideTour.guide.label').toString()
    };
  },

  components: {
    ToHelper: ToHelper,
    AccountFeedback: AccountFeedback
  },
  props: {
    visibilityHeight: {
      type: Number,
      default: 100
    },
    right: {
      type: Number,
      default: 48
    },
    bottom: {
      type: Number,
      default: 48
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('resize', this.initBox);
    this.robserver = new ResizeObserver(function (entries) {
      _this.initBox();
    });
    this.robserver.observe(this.$refs['barRef']);
    ptEventter.on('showTemporaryTipContent', function () {
      _this.showTemporaryTooltip();
    });
  },
  destroyed: function destroyed() {
    this.robserver = null;
    window.removeEventListener('resize', this.initBox);
  },

  methods: {
    mousedown: function mousedown(e) {
      var barRef = this.$refs['barRef'];
      var disX = e.offsetX;
      var disY = e.offsetY;
      var that = this;
      document.onmousemove = function (e) {
        var maxWidth = that.winWidth - barRef.clientWidth;
        var maxHeight = that.winHeight - barRef.clientHeight;
        var x = maxWidth;
        var y = maxHeight;
        if (e.clientY - disY > 0 && e.clientY - disY < maxHeight) {
          y = e.clientY - disY + 'px';
        } else if (e.clientY - disY < 0) {
          y = 0 + 'px';
        } else {
          y = maxHeight + 'px';
        }
        if (e.clientX - disX > 0 && e.clientX - disX < maxWidth) {
          x = maxWidth - (e.clientX - disX) + 'px';
        } else if (e.clientX - disX < 0) {
          x = maxWidth + 'px';
        } else {
          x = 10 + 'px';
        }
        barRef.style.top = y;
        barRef.style.right = x;
      };
      document.onmouseup = function (e) {
        document.onmousemove = document.mousedown = null;
      };
    },
    initBox: function initBox() {
      var _this2 = this;

      this.$nextTick(function () {
        var barRef = _this2.$refs['barRef'];
        if (barRef) {
          _this2.winWidth = window.innerWidth;
          _this2.winHeight = window.innerHeight;
          var maxWidth = _this2.winWidth - barRef.clientWidth;
          var maxHeight = _this2.winHeight - barRef.clientHeight;
          if (barRef.style.top === '' && barRef.style.right === '' || barRef.offsetLeft > maxWidth || barRef.offsetTop > maxHeight) {
            barRef.style.right = 10 + 'px';
            barRef.style.top = maxHeight + 'px';
          }
        }
      });
    },
    handleClick: function handleClick(event) {
      this.handleLogin();
    },
    handleToHelper: function handleToHelper() {
      var url = 'https://www.yuque.com/gh6rns';
      window.open(url, '_blank');
    },
    handleLogin: function handleLogin() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var loading;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = _this3.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });

                try {
                  _this3.$store.dispatch('pt/loginToSs');
                  loading.close();
                } catch (error) {
                  console.log(error);
                  loading.close();
                }

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    handleMessage: function handleMessage() {
      this.dialogVisible = true;
    },
    handleGuide: function handleGuide() {
      this.$router.push({
        name: 'home.index'
      });

      ptEventter.emit('showGuide');
    },
    showTemporaryTooltip: function showTemporaryTooltip() {
      var _this4 = this;

      var triggerGuide = this.$refs['triggerGuide'];
      this.guideText = t('playTurbo.guideTour.guide.tips').toString();
      triggerGuide.show();

      setTimeout(function () {
        triggerGuide.hide();
        setTimeout(function () {
          _this4.guideText = t('playTurbo.guideTour.guide.label').toString();
        }, 400);
      }, 3000);
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    toggleHoverMsg: function toggleHoverMsg(val) {
      this.messageIconColor = val;
    },
    toggleHoverGuide: function toggleHoverGuide(val) {
      this.guideIconColor = val;
    },
    toggleHoverAssistant: function toggleHoverAssistant(val) {
      this.assistantIconColor = val;
    },
    handleCancel: function handleCancel() {
      this.handleClose();
    },
    handleSuccess: function handleSuccess() {
      this.handleClose();
    }
  },
  computed: _extends({}, mapState({
    downloadTaskDialog: function downloadTaskDialog(state) {
      return state.creative.downloadTask.downloadTaskDialog;
    }
  }), {
    innerRight: function innerRight() {
      return this.downloadTaskDialog.visible ? 368 : 24;
    },

    dialogVisible: {
      get: function get() {
        return this.$store.state.pt.feedback.userMessageDialogVisible;
      },
      set: function set() {
        this.$store.dispatch('pt/feedback/toggleDialogVisible');
      }
    }
  })
};